<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="section">

        <div class="top_header">
            <div class="item">
                <div class="label">
                    {{'ODCDASHBOARD.odcDashboard'| translate}}
                </div>

            </div>
        </div>
        <div class="search_with">
            <div class="search_box">
                <div class="search_inside_box">
                    <div class="left">
                        <div class="search_item">
                            <mat-select class="inputSelectdropdown" [(ngModel)]="selectedSearch">
                                <mat-option *ngFor="let option of searchWithOptions" [value]="option"
                                    (click)="selectSearchOption(option)">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div>
                            <input type="text" class="search_input" [(ngModel)]="inputSearch"
                                [placeholder]="selectedSearch.type=='odNo' ? 'Search OD No.' : 'Search SIN No.'">
                        </div>
                    </div>
                    <div class="right" (click)="submitSearch()">
                        <img src="assets/search_icon_new.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="filters_sec">
            <div class="left">
                <div class="filter">
                    <div class="input did-floating-label-content">
                        <input type="text" class="inputField did-floating-input" placeholder=" " [(ngModel)]="fromDate"
                            [min]="minDate" (click)="fromDateInput3.open()" [matDatepicker]="fromDateInput3" />
                        <label class="did-floating-label">{{'From' |
                            translate}}</label>
                        <mat-datepicker #fromDateInput3 (closed)="getOdcDetails()">
                        </mat-datepicker>
                    </div>
                </div>
                <div class="filter">
                    <div class="input did-floating-label-content">
                        <input type="text" class="inputField did-floating-input" placeholder=" " [(ngModel)]="toDate"
                            [min]="minDate" (click)="toDateInput3.open()" [matDatepicker]="toDateInput3" />
                        <label class="did-floating-label">{{'To' |
                            translate}}</label>
                        <mat-datepicker #toDateInput3 (closed)="getOdcDetails()">
                        </mat-datepicker>
                    </div>
                </div>
                <div class="item status_select">
                    <mat-form-field appearance="outline" style="outline: none;">
                        <mat-label style="font-size: 12px !important;font-weight: bold;">{{'Status' |
                            translate}}</mat-label>
                        <mat-select [(ngModel)]="selectedStatus">
                            <mat-option *ngFor="let option of statuses" [value]="option" (click)="selectStatus(option)">
                                <span>{{option}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div style="cursor: pointer;margin-top: 8px;" (click)="getOdcDetails()">
                <img src="assets/refresh-icon.svg" alt="" style="cursor: pointer;">
            </div>

        </div>

        <div class="body">
            <div class="table">
                <table mat-table [dataSource]="odcDatasource" *ngIf="odcDatasource.length > 0">

                    <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef style="width: 64px;padding-left: 16px;text-align: left;">
                            {{'ODCDASHBOARD.sno'| translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index"
                            style="width: 64px;padding-left: 16px;text-align: left;"> {{i+1}} </td>
                    </ng-container>
                    <ng-container matColumnDef="sin">
                        <th mat-header-cell *matHeaderCellDef> {{'ODCDASHBOARD.sin'| translate}} </th>
                        <td mat-cell *matCellDef="let element;"> {{element.sin}} </td>
                    </ng-container>

                    <ng-container matColumnDef="pickup">
                        <th mat-header-cell *matHeaderCellDef> {{'ODCDASHBOARD.pickup&Delivery'| translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngFor="let pick of element.pickups">
                                <div class="pickup_timeline">
                                    <div class="pickup_image">
                                        <div><img src="assets/pickup_icon.svg" alt=""></div>
                                        <div class="vertical_line"></div>
                                    </div>
                                    <div class="pickup_time">
                                        <div class="pick_name" matTooltip="{{pick.location.name}}">
                                            {{pick.location.name}}</div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                            <div class="vertical-line"></div>
                            <div *ngFor="let delivery of element.deliveries;let i = index;let isLast = last">
                                <div class="pickup_timeline">
                                    <div class="pickup_image">
                                        <div><img src="assets/drop_icon.svg" alt=""></div>
                                        <div class="vertical_line" *ngIf="!isLast"></div>
                                    </div>
                                    <div class="pickup_time">
                                        <div class="pick_name" matTooltip="{{delivery.location.name}}">
                                            {{delivery.location.name}}</div>
                                        <div></div>
                                    </div>
                                </div>

                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="odNo">

                        <th mat-header-cell *matHeaderCellDef> {{'ODCDASHBOARD.odNo'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.do_numbers || '---'}}</td>
                    </ng-container>


                    <ng-container matColumnDef="odcRequest">
                        <th mat-header-cell *matHeaderCellDef> {{'ODCDASHBOARD.odcRequest'| translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="od_request_sec">
                                <div class="odc_request" [ngStyle]="getStatusStyles(element.status)">{{element.status |
                                    titlecase}}
                                </div>
                            </div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="carrierComment">
                        <th mat-header-cell *matHeaderCellDef> {{'ODCDASHBOARD.carrierComment'| translate}} </th>
                        <td mat-cell *matCellDef="let element">{{element.carrier_comments}}</td>
                    </ng-container>

                    <ng-container matColumnDef="shipperComment">
                        <th mat-header-cell *matHeaderCellDef> {{'ODCDASHBOARD.Shippercomment'| translate}} </th>
                        <td mat-cell *matCellDef="let element">{{element.shipper_comments}} </td>
                    </ng-container>

                    <ng-container matColumnDef="attachments">
                        <th mat-header-cell *matHeaderCellDef> {{'ODCDASHBOARD.attachments'| translate}}</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="attachments_sec">
                                <div>
                                    <a *ngIf="previewPdf && !isImage" [href]="previewPdf" download
                                        style="cursor: pointer;">
                                        <img src="assets/download_pdf.svg" alt="">
                                    </a>
                                    <a *ngIf="previewImage && isImage" [href]="previewImage" download
                                        style="cursor: pointer;">
                                        <img src="assets/download_pdf.svg" alt="">
                                    </a>
                                </div>

                                <div (click)="openImagePopup()" class="document_preview">
                                    {{'ODCDASHBOARD.odcFineDocument' | translate}}</div>
                            </div>

                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row;let i=index; columns: displayedColumns;"
                        [ngClass]="{'highlightTableColor': selectedRowIndex == i}">
                    </tr>
                </table>
            </div>
            <mat-paginator fixed [length]="odcDatasource ? totalOdcCount : 0" [pageSize]="10"
                [pageSizeOptions]="[200, 400, 500]" [showFirstLastButtons]="true" (page)="pageNavigate($event)">
            </mat-paginator>
        </div>
    </div>
</div>
<ng-template #showData>
    <div class="rowDataDialog">
        <div class="dialog_header">
            <div class="dialog_title">{{vehicleNumber}} / {{odNumber}}</div>
            <div class="dialog_close" (click)="showDialogRef.close()">
                <i class="material-icons">close</i>
            </div>
        </div>
        <div class="dialog_body">

            <ul *ngFor="let row of rowData">

                <li style="--accent-color:#002563">
                    <div class="icon"><i class="fa-brands fa-css3"></i></div>
                    <div class="title">{{'CLOSEDTRIPSDETAILS.source_location'| translate}}</div>
                    <div class="descr">{{ row.srcLoc || 'N/A'}}</div>
                </li>
                <li style="--accent-color:#002563">
                    <div class="icon"><i class="fa-brands fa-css3"></i></div>
                    <div class="title">{{'CLOSEDTRIPSDETAILS.destination'| translate}}</div>
                    <div class="descr">{{ row.destination || 'N/A'}}</div>
                </li>

                <li style="--accent-color:#002563">
                    <div class="icon"><i class="fa-brands fa-css3"></i></div>
                    <div class="title">{{'CLOSEDTRIPSDETAILS.entry_no'| translate}}</div>
                    <div class="descr">{{ row.entry_no || 'N/A'}}</div>
                </li>

            </ul>
        </div>
    </div>
</ng-template>

<ng-template #noData>
    <app-no-data></app-no-data>
</ng-template>


<ng-template #approveDisapproveDialog>
    <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="closeModal();">
        <mat-icon class="close-icon">close</mat-icon>
    </button>
    <div class="Report_dialog">
        <div class="header">
            <div class="header_title"> {{elementType=='approve' ? 'Approve': 'Disapprove'}} / {{dialogData.sin}}</div>
        </div>
        <div class="section">
            <input type="text" class="input_field" [(ngModel)]="updateComments">
        </div>
        <div class="buttons">
            <div class="clear_btn" (click)="approveDialogRef.close()">Clear</div>
            <div class="submit_btn" (click)="odcRequest()">Submit</div>
        </div>
    </div>
</ng-template>
<div id="myPopup">
    <div class="close_btn">
        <i class="material-icons close_icon" (click)="closePopup()">
            clear
        </i>
    </div>
    <div class="body">
        <img *ngIf="isImage" [src]="previewImage" alt="No Epod found" />
        <app-pdf-viewer *ngIf="isPdf" [src]="previewPdf" [full]="true" style="width: 98%;
            height: 100%;"></app-pdf-viewer>
    </div>
</div>

